<template>
    <div class="result-summary-bar px-3 py-2 my-1">
        <span class="summary-total">
            <font-awesome-icon icon="list" class="summary-icon" />
            {{ totalCount }} {{ $t('common.pcs')}}
        </span>
        <span class="summary-divider" aria-hidden="true">|</span>
        <span v-if="openCount > 0" class="summary-status-pill summary-status-pill--open">
            {{ $t('observations.open') }}: <strong>{{ openCount }}</strong>
        </span>
        <span v-if="closedCount > 0" class="summary-status-pill summary-status-pill--closed">
            {{ $t('observations.closed') }}: <strong>{{ closedCount }}</strong>
        </span>
    </div>
</template>

<script>
export default {
    name: 'ObservationResultSummary',

    props: {
        results: {
            type: Array,
            required: true
        }
    },

    computed: {
        totalCount() {
            return this.results.length
        },
        openCount() {
            return this.results.filter(item => !item.closed_time).length
        },
        closedCount() {
            return this.results.filter(item => !!item.closed_time).length
        }
    }
}
</script>

<style scoped>
.result-summary-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1em 0.75em;
    width: 100%;
    background: #ffffff;
    border: 1px solid #c8e07a;
    border-radius: 0.4em;
    padding: 1em 0.75em;
    margin-top: 0.3em;
    margin-bottom: 0.3em;
    font-size: 0.88em;
    color: #404041;
    box-sizing: border-box;
}

.summary-icon {
    color: #7FC000;
    margin-right: 0.75em;
}

.summary-total {
    white-space: nowrap;
    font-size: 1.2rem;
}

.summary-divider {
    color: #5f8f01;
    font-weight: 300;
    user-select: none;
    margin: 0 1em;
}

.summary-status-pill {
    display: inline-block;
    padding: 0.25em 0.6em;
    font-size: 0.85em;
    min-width: 5rem;
    text-align: center;
    border: 1px solid !important;
    border-radius:  9999px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

}

/* Open observations — app's status-open tint */
.summary-status-pill--open {
    background: #aef8d3;
    border-color: #06bea8;
    color: #1a4a3a;
}

/* Closed observations — app's status-closed tint */
.summary-status-pill--closed {
    background: #e9eaed;
    border-color: #9a9ba0;
    color: #404041;
}
</style>
